$(document).ready(function(){

	if($('.positions-container').length > 0){
		set_menu_default_positions();
	}
	$('.menu-groups a').on('click', function(e){
		e.preventDefault();
		$('.positions-container .group').fadeOut(500);
		$('.positions-container .group[data-group="'+$(this).attr('class')+'"]').fadeIn(500);
		$('.menu-groups a').removeClass('active');
		$(this).addClass('active');
		set_menu_group_positions();
	});
	function set_menu_default_positions(){
		$('.left-col .group').each(function(){
			if($(this).attr('data-default-col') == 'prawa'){
				$('.right-col').append($(this));
			}
		});
		$('.positions-container').css('display', 'flex');
	}
	function set_menu_group_positions(){
		$('.right-col .group').each(function(){
			$('.left-col').append($(this));
		});
		$('.left-col .group').each(function(){
			if($(this).attr('data-group-col') == 'prawa'){
				$('.right-col').append($(this));
			}
		});
	}

	$('.home-slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		autoplay: true,
		autoplaySpeed: 6000,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchThreshold: 90,
	});
	$('.news-slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		autoplay: true,
		autoplaySpeed: 6000,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		touchThreshold: 90,
	});
	$('.reviews-slider').slick({
		dots: true,
		infinite: true,
		speed: 300,
		autoplay: true,
		autoplaySpeed: 8000,
		arrows: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		touchThreshold: 90,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	function show_fullscreen_menu(){
		$('.full-screen-menu').fadeIn(500);
	}
	function show_top_contact(){
		$('.top-contact').fadeIn(500);
	}
	$('.full-screen-menu .close').on('click', function(e){
		e.preventDefault();
		$('.full-screen-menu').fadeOut(500);
	});
	$('.top-contact .close').on('click', function(e){
		e.preventDefault();
		$('.top-contact').fadeOut(500);
	});
	$('header .bars').on('click', function(e){
		e.preventDefault();
		if($(window).width() < 992){
			show_fullscreen_menu();
		}
		else{
			show_top_contact();
		}
	});

});